import { formatLocationObject } from '../'

export const getBounds = (bounds, type) => {
  if (!(type === 'ELASTIC_SEARCH' || type === 'GOOGLE_MAPS') || !bounds)
    return null

  const northeast = bounds.ne || bounds.northeast
  const southwest = bounds.sw || bounds.southwest

  if (type === 'ELASTIC_SEARCH')
    return {
      ne: formatLocationObject(northeast, 'ELASTIC_SEARCH'),
      sw: formatLocationObject(southwest, 'ELASTIC_SEARCH')
    }
  if (type === 'GOOGLE_MAPS')
    return {
      ne: formatLocationObject(northeast, 'GOOGLE_MAPS'),
      sw: formatLocationObject(southwest, 'GOOGLE_MAPS')
    }
}
